function stripWrapperNoise(raw) {
  let s = String(raw).trim();
  if (s.startsWith('`') && s.endsWith('`')) s = s.slice(1, -1);
  return s
    .replace(/^\uFEFF/, '')
    .replace(/[\u200B-\u200D\u2060\u00A0]/g, '')
    .replace(/\r\n?/g, '\n');
}

function parseInnerJson(responseStr) {
  try {
    return JSON.parse(responseStr);
  } catch {
    const unescaped = responseStr.replace(/\\n/g, '\n').replace(/\\"/g, '"').replace(/\\\\/g, '\\').trim();
    try {
      return JSON.parse(unescaped);
    } catch {
      return responseStr;
    }
  }
}

function normalizeEntries(outer) {
  const items = outer.answer || outer.answer_list;
  if (!Array.isArray(items)) return null;

  return items.map((entry) => {
    const [[question, responseStr]] = Object.entries(entry);
    return { question, response: parseInnerJson(responseStr) };
  });
}

/**
 * Parses a raw agent output string into a structured object.
 * @param {string} raw - The raw output string from an agent step
 * @returns {{ id: any, answer: Array<{ question: string, response: any }> } | null}
 */
export function parseAgentOutput(raw) {
  try {
    const cleaned = stripWrapperNoise(raw);
    const outer = JSON.parse(cleaned);
    const answer = normalizeEntries(outer);
    if (!answer) return null;
    return { id: outer.id, answer };
  } catch {
    return null;
  }
}
